<template>
  <div v-editable="blok" :class="blockClasses">
    <div class="copy">
      <div class="copy-container">
        <h4 v-if="blok.title!=''" class="title">{{ blok.title }}</h4>
        <div v-if="blok.copy!=''" class="copy-text" v-html="blok.copy.html"></div>
        <div v-if="blok.cta && blok.cta.id!=''" class="cta">
          <cta-button :blok="blok"></cta-button>
        </div>
      </div>
    </div>
    <div ref="imageContainer" :class="imageClasses" :style="style"></div>
  </div>
</template>
<script>
import CtaButton from "./CtaButton.vue";

export default {
  name: "summary-card",
  components: {
    CtaButton
  },
  props: ["blok"],
  data: () => {
    return {
      style: ''
    }
  },
  computed: {
    blockClasses: function() {
        const b = this.$props.blok;
      return [
        "summary-card",
        b.decoration ?  b.decoration.join(' ') : ''
      ];
    },
    imageClasses: function() {
        const b = this.$props.blok;
      return [
        "image",
        b.image_decoration
      ];
    },
  },
  mounted: function() {
    const rect = this.$refs.imageContainer.getBoundingClientRect();
    const width = rect.width;
    const height = rect.height;
    const image = this.$options.filters.optimizeImage(this.blok.image,width,height);
    this.style = {
      backgroundImage: `url(${image})`
    };
  }
};
</script>
